__turbopack_context__.v({
  "emptySlide": "SpaceSlider-module-scss-module__6p5feW__emptySlide",
  "image": "SpaceSlider-module-scss-module__6p5feW__image",
  "mainTitle": "SpaceSlider-module-scss-module__6p5feW__mainTitle",
  "navigation": "SpaceSlider-module-scss-module__6p5feW__navigation",
  "navigationButton": "SpaceSlider-module-scss-module__6p5feW__navigationButton",
  "prev": "SpaceSlider-module-scss-module__6p5feW__prev",
  "slide": "SpaceSlider-module-scss-module__6p5feW__slide",
  "slider": "SpaceSlider-module-scss-module__6p5feW__slider",
  "swiperSlide": "SpaceSlider-module-scss-module__6p5feW__swiperSlide",
  "title": "SpaceSlider-module-scss-module__6p5feW__title",
});
